export const FilterType = {
    String: 'string',
    OrderStatus: 'orderStatus',
    Int: 'int',
    Boolean: 'boolean',
    BooleanNot: '!boolean',
    Date: 'date'
}

